import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from 'src/app/pipes/pipes.module';

import { InventorySummaryComponent } from './inventory-summary.component';

@NgModule({
  declarations: [InventorySummaryComponent],
  exports: [InventorySummaryComponent],
  imports: [CommonModule, PipesModule],
})
export class InventorySummaryModule {}
